import { z } from 'zod';
import { BaseEntitySchema, HexColorSchema } from './common';
import { ImageId, PlayerId, TeamId, UserId } from './ids';

export const TeamScoringTypeSchema = z.enum(['combined', 'individual']);
export type TeamScoringType = z.infer<typeof TeamScoringTypeSchema>;

export const TeamSchema = BaseEntitySchema.extend({
  id: TeamId,
  name: z
    .string()
    .max(100)
    .optional()
    .refine((value) => value === undefined || value.trim().length > 0, {
      message: 'Name must have at least 1 non-space character',
    }),
  nickname: z
    .string()
    .max(50)
    .optional()
    .refine((value) => !value || (value.trim().length > 0 && /\p{L}/u.test(value)), {
      message: 'Nickname must contain at least one letter',
    }),
  avatarImageId: ImageId.optional(),
  color: HexColorSchema.optional(),
  playerIds: z.array(PlayerId).min(1),
});
export type Team = z.infer<typeof TeamSchema>;

export const TeamPresetSchema = BaseEntitySchema.extend({
  id: TeamId,
  name: z
    .string()
    .max(100)
    .optional()
    .refine((value) => value === undefined || value.trim().length > 0, {
      message: 'Name must have at least 1 non-space character',
    }),
  nickname: z
    .string()
    .max(50)
    .optional()
    .refine((value) => !value || (value.trim().length > 0 && /\p{L}/u.test(value)), {
      message: 'Nickname must contain at least one letter',
    }),
  avatarImageId: ImageId.optional(),
  color: z
    .string()
    .regex(/^#[0-9A-Fa-f]{6}$/)
    .optional(),
  playerIds: z.array(PlayerId).optional(), // preset can include default players
  userId: UserId.optional(), // Optional: system presets don't have userId, user presets do
});
export type TeamPreset = z.infer<typeof TeamPresetSchema>;
